import React from "react";
import { Card } from "antd";
import { withNamespaces } from "react-i18next";
import { decodeHtmlEntities } from "utils/decodeHtmlEntities";

const cardStyle = {
  width: "100%",
  border: "none",
  borderRadius: "10px",
  backgroundColor: "#F7F6F6",
};

const DataItem = ({ label, value, isLast }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      borderBottom: isLast ? "none" : "1px solid #D0D0D0",
      flexWrap: "wrap",
    }}
  >
    <p style={{ color: "black" }}>{label}</p>
    <p style={{ color: "grey" }}>{value}</p>
  </div>
);

export const getLawfulBasisOfProcessing = (t, lawfulBasisOfProcessing) =>
  t(
    `dataAgreements.lawfulBasisValues.${
      lawfulBasisOfProcessing || "legitimate_interest"
    }`
  );

export const getThirdPartyDisclosure = (t, thirdPartyDisclosure) => {
  if (typeof thirdPartyDisclosure !== "boolean") {
    return "";
  }

  return t(
    `dataAgreements.boolean.${thirdPartyDisclosure ? "true" : "false"}`
  );
};

export const getRetentionPeriod = (t, retentionPeriodDays) => {
  if (typeof retentionPeriodDays !== "number") {
    return "";
  }

  if (retentionPeriodDays >= 365 && retentionPeriodDays % 365 === 0) {
    const years = retentionPeriodDays / 365;

    return t(`dataAgreements.retention.year_${years > 1 ? "other" : "one"}`, {
      count: years,
    });
  }

  return t(
    `dataAgreements.retention.day_${
      retentionPeriodDays > 1 ? "other" : "one"
    }`,
    {
      count: retentionPeriodDays,
    }
  );
};

export const DataAgreementDetails = ({
  t,
  purpose,
  purposeDescription,
  lawfulBasisOfProcessing,
  policyURL,
  jurisdiction,
  thirdPartyDisclosure,
  industryScope,
  geographicRestriction,
  retentionPeriodDays,
  storageLocation,
}) => {
  const data1 = [
    { key: t("dataAgreements.purpose"), value: decodeHtmlEntities(purpose) },
    {
      key: t("dataAgreements.purposeDescription"),
      value: decodeHtmlEntities(purposeDescription),
    },
    {
      key: t("dataAgreements.lawfulBasisOfProcessing"),
      value: getLawfulBasisOfProcessing(t, lawfulBasisOfProcessing),
    },
  ];

  const data2 = [
    { key: t("dataAgreements.policyURL"), value: decodeHtmlEntities(policyURL) },
    {
      key: t("dataAgreements.jurisdiction"),
      value: decodeHtmlEntities(jurisdiction),
    },
    {
      key: t("dataAgreements.thirdPartyDisclosure"),
      value: getThirdPartyDisclosure(t, thirdPartyDisclosure),
    },
    {
      key: t("dataAgreements.industryScope"),
      value: decodeHtmlEntities(industryScope),
    },
    {
      key: t("dataAgreements.geographicRestriction"),
      value: decodeHtmlEntities(geographicRestriction),
    },
    {
      key: t("dataAgreements.retentionPeriod"),
      value: getRetentionPeriod(t, retentionPeriodDays),
    },
    {
      key: t("dataAgreements.storageLocation"),
      value: decodeHtmlEntities(storageLocation),
    },
  ];

  return (
    <>
      <Card style={cardStyle}>
        {data1.map(({ key, value }, index) => (
          <DataItem
            key={key}
            label={key}
            value={value}
            isLast={index === data1.length - 1}
          />
        ))}
      </Card>
      <Card
        style={{
          ...cardStyle,
          marginTop: "20px",
        }}
      >
        {data2.map(({ key, value }, index) => (
          <DataItem
            key={key}
            label={key}
            value={value}
            isLast={index === data2.length - 1}
          />
        ))}
      </Card>
    </>
  );
};

export const DataAgreementDetailsWithNamespace = withNamespaces()(
  DataAgreementDetails
);

export default DataAgreementDetailsWithNamespace;
